import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react'

/**
 * Content this editor does not model.
 *
 * Shown as an explicitly marked, non-editable block rather than hidden or
 * dropped. The underlying mdast is carried through a save untouched, so opening a
 * page with an unfamiliar construct and saving it cannot damage that construct —
 * it just cannot be edited here. Silently losing it would be far worse.
 */
export function UnknownView({ node }: NodeViewProps) {
  const mdast = node.attrs['mdast'] as { type?: string; value?: string } | undefined
  const label = mdast?.type ?? 'unknown'
  const value = typeof mdast?.value === 'string' ? mdast.value : JSON.stringify(mdast)
  return (
    <NodeViewWrapper className="be-unknown" data-sls="unknown">
      <div className="be-unknown__tag" contentEditable={false}>
        {label} · preserved, not editable here
      </div>
      <pre className="be-unknown__body" contentEditable={false}>
        {value?.slice(0, 600)}
      </pre>
    </NodeViewWrapper>
  )
}

/** A directive with a name the schema does not know. Contents stay editable. */
export function GenericDirectiveView({ node }: NodeViewProps) {
  const name = node.attrs['name'] as string
  const attrs = (node.attrs['attributes'] ?? {}) as Record<string, string>
  const pairs = Object.entries(attrs)
  return (
    <NodeViewWrapper className="be-generic" data-sls="generic">
      <div className="be-generic__tag" contentEditable={false}>
        :::{name}
        {pairs.length > 0 && (
          <span className="be-generic__attrs">
            {pairs.map(([k, v]) => `${k}="${v}"`).join(' ')}
          </span>
        )}
      </div>
      <NodeViewContent />
    </NodeViewWrapper>
  )
}
